import { Box, Paper, Skeleton } from '@mui/material';

export const MessagesSkeleton = () => (
  <Paper
    elevation={0}
    sx={(theme) => ({
      display: 'flex',
      gap: '1.5rem',
      padding: '1.5rem',
      height: '10rem',
      width: '100%',
      border: `.1rem solid ${theme.palette.grey[300]}`,
      borderRadius: 0,
      borderBottom: 0,
      '&:last-child': {
        borderBottom: `.1rem solid ${theme.palette.grey[300]}`,
      },
    })}
  >
    <Skeleton height="6rem" width="6rem" variant="rounded" />
    <Box sx={{ flexGrow: 1 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '1.5rem',
        }}
      >
        <Skeleton width="50%" />
        <Skeleton width="20%" />
      </Box>

      <Skeleton width="25%" />
    </Box>
  </Paper>
);

export const MessageItemSkeleton = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '2rem',
      width: '100%',
    }}
  >
    <Skeleton
      width="80%"
      height="12rem"
      sx={{ borderRadius: '1.5rem 0 1.5rem 1.5rem', alignSelf: 'flex-end' }}
      variant="rectangular"
    />
    <Skeleton sx={{ alignSelf: 'center' }} width="15rem" variant="rounded" />
    <Skeleton
      width="80%"
      height="12rem"
      sx={{ borderRadius: '0 1.5rem 1.5rem 1.5rem' }}
      variant="rectangular"
    />
    <Skeleton
      width="80%"
      height="12rem"
      sx={{ borderRadius: '0 1.5rem 1.5rem 1.5rem' }}
      variant="rectangular"
    />
  </Box>
);

export const MessageThreadSkeleton = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      gap: '15rem',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem',
        width: '100%',
      }}
    >
      <Skeleton height="3rem" width="40%" variant="rounded" />
      <Skeleton height="2.5rem" width="60%" variant="rounded" />
    </Box>
    <MessageItemSkeleton />
  </Box>
);

export const MessageRecipientSkeleton = () => (
  <Box
    sx={{
      height: '5rem',
      width: '100%',
      borderBottom: '.1rem solid #e0e0e0',
      display: 'flex',
    }}
  >
    <Box
      sx={{
        width: '4.2rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Skeleton sx={{ width: '2rem', height: '2rem' }} variant="rounded" />
    </Box>
    <Box sx={{ display: 'flex', gap: '1rem', width: '100%' }}>
      <Box sx={{ width: '40%', display: 'flex', alignItems: 'center' }}>
        <Skeleton sx={{ width: '60%', height: '2rem' }} variant="rounded" />
      </Box>
      <Box sx={{ width: '35%', display: 'flex', alignItems: 'center' }}>
        <Skeleton sx={{ width: '40%', height: '2rem' }} variant="rounded" />
      </Box>
      <Box sx={{ width: '20%', display: 'flex', alignItems: 'center' }}>
        <Skeleton sx={{ width: '30%', height: '2rem' }} variant="rounded" />
      </Box>
    </Box>
  </Box>
);
